import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';

const SelectIndiretoModal = ({ show, onHide, custosIndiretos, onSelect }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Selecionar Custo Indireto de Outro Mês</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ListGroup>
                    {custosIndiretos.map((custo) => (
                        <ListGroup.Item 
                            key={custo.id} 
                            action 
                            onClick={() => onSelect(custo)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{custo.descricao_custo_indireto}</strong>
                                    <div className="text-muted">
                                        Mês: {custo.mes_ano}
                                    </div>
                                </div>
                                <div className="text-end">
                                    <div>Tipo: {custo.tipo}</div>
                                    <div>Valor: {custo.valor_custo_indireto}</div>
                                    <div>Moeda: {custo.moeda}</div>
                                </div>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SelectIndiretoModal; 